import { render, staticRenderFns } from "./OtherProperty.vue?vue&type=template&id=0823f943"
import script from "./OtherProperty.vue?vue&type=script&lang=js"
export * from "./OtherProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports